module.exports = ".flex-page-content{\r\n    padding: 20px;\r\n    padding-top: 150px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: start;\r\n        -ms-flex-pack: start;\r\n            justify-content: start;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/claim-account/claim-account.component.css
// module id = ./src/app/claim-account/claim-account.component.css
// module chunks = main